import { propertiesSelect } from '@/utils'

import { serviceName } from '@/components/services/servers/utils'

export default {
  name: 'Properties',

  mixins: [ propertiesSelect({ serviceName }) ]
}
